// Decorated pot (M42). PURE (ENG-1). A pot crafted from pottery sherds holds a
// single stack: right-clicking with an item stows it (topping up a matching stack),
// right-clicking empty-handed pulls the stack back out. These are the storage rules.

/** A decorated pot holds one stack. */
export const POT_SLOTS = 1;

export interface PotStack { item: number; count: number }

/** Insert `incoming` into a pot holding `current` (or null). Returns the new stored
 *  stack and how many items could not fit. Only same-item stacks merge; a
 *  full/mismatched pot rejects (leftover === incoming.count). */
export function potInsert(
  current: PotStack | null,
  incoming: PotStack,
  maxStack: number,
): { stored: PotStack; leftover: number } {
  if (incoming.count <= 0) return { stored: current ?? { item: 0, count: 0 }, leftover: 0 };
  if (!current || current.count === 0) {
    const take = Math.min(incoming.count, maxStack);
    return { stored: { item: incoming.item, count: take }, leftover: incoming.count - take };
  }
  if (current.item !== incoming.item) return { stored: current, leftover: incoming.count };
  const take = Math.min(incoming.count, maxStack - current.count);
  return { stored: { item: current.item, count: current.count + take }, leftover: incoming.count - take };
}

/** Comparator signal a pot emits by fullness (0 empty → 15 full, MC container curve). */
export function potComparator(count: number, maxStack: number): number {
  if (count <= 0) return 0;
  return Math.floor(1 + (count / maxStack) * 14);
}
